import React from "react";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Card from "../../components/Card/Card";
import CardIcon from "../../components/Card/CardIcon";
import { ImportExport } from "@mui/icons-material";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import GridContainer from "../../components/Grid/GridContainer";
import FormV2 from "../JamezzForm/FormV2";
import FormAsyncTC from "../../components/Forms/FormAsyncTC";
import FormFile from "../../components/Forms/FormFile";
import AuthProvider from "../../auth/AuthProvider";
import { Typography, Alert } from "@mui/material";

function Index(props) {
  return (
    <AuthProvider prefix={"importexport"}>
      <MainNavbar paginaTitel={"Importeren en exporteren van verkoopgebied"} />
      <Alert severity={"warning"}>
        Salesarea references are copied <em>as is</em>. Will result in <b>foreign key errors</b> after importing if it
        references other salesareas. Fix these manually when relevant.
      </Alert>
      <Card>
        <CardHeader color={"primary"} icon>
          <CardIcon color={"primary"}>
            <ImportExport />
          </CardIcon>
          <Typography sx={{ color: "black" }}>
            <TranslationWrapper tDefault={"Exporteer verkoopgebied"} tKey={"importexport.card.title"} />
          </Typography>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <FormV2
              afterSubmit={(result) => {
                if (result?.item) {
                  window.location.href = result.item;
                }
              }}
              endPoint={"core/Importexport/downloadLink"}
              isSaveButtonSticky={false}
              pageTitle={"importexport"}
            >
              <FormAsyncTC
                async={{
                  url: "core/vestigingen/search?fields=id as value, systeemNaam as label",
                  searchField: "systeemNaam",
                  perPage: 50,
                }}
                name={"salesarea_id"}
                rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
                tDefault={"Sales area"}
                tKey={"importexport.form.algemeen.label.vestiging"}
              />
            </FormV2>
          </GridContainer>
        </CardBody>
      </Card>
      <Card>
        <CardHeader color={"primary"} icon>
          <CardIcon color={"primary"}>
            <ImportExport />
          </CardIcon>
          <Typography sx={{ color: "black" }}>
            <TranslationWrapper tDefault={"Importeer verkoopgebied"} tKey={"importexport.card.title"} />
          </Typography>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <FormV2 endPoint={"core/Importexport/import"} isSaveButtonSticky={false} pageTitle={"importexport"}>
              <FormFile name={"bestand"} />
            </FormV2>
          </GridContainer>
        </CardBody>
      </Card>
      {/*<Card>*/}
      {/*  <CardHeader color="primary" icon>*/}
      {/*    <CardIcon color="primary">*/}
      {/*      <ImportExport />*/}
      {/*    </CardIcon>*/}
      {/*    <Typography sx={{ color: "black" }}>Quick settings</Typography>*/}
      {/*  </CardHeader>*/}
      {/*  <CardBody>*/}
      {/*    <GridContainer>*/}
      {/*      <FormV2 endPoint={"../dev/quick_settings"} pageTitle={"quick_settings"} isSaveButtonSticky={false}>*/}
      {/*        <FormFile name={"bestand"} />*/}
      {/*      </FormV2>*/}
      {/*    </GridContainer>*/}
      {/*  </CardBody>*/}
      {/*</Card>*/}
    </AuthProvider>
  );
}

export default Index;
